import { ScannedHistoryConstants } from "../constants";

export function ScannedHistory(state = {}, action) {
  switch (action.type) {
    case ScannedHistoryConstants.LOADING_REQUEST:
      return {
        ...state,
        loding: action.isbool,
      };
    case ScannedHistoryConstants.GETALL_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ScannedHistoryConstants.GETALL_SUCCESS:
      return {
        ...state,
        items: action.datas,
      };
    case ScannedHistoryConstants.GETALL_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case ScannedHistoryConstants.GETEXPORT_REQUEST:
      return {
        ...state,
        exporting: true,
      };
    case ScannedHistoryConstants.GETEXPORT_SUCCESS:
      return {
        ...state,
        exportitems: action.datas,
      };
    case ScannedHistoryConstants.GETEXPORT_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    default:
      return state;
  }
}
